import { __assign } from 'tslib';
import { isEqual } from 'lodash';
import { ErrorType } from '../ModalBuilder.models.esm.js';
import 'squirrelly';
import '../postProcessingActions/processLocationValidationError.esm.js';
import { LOCATION_VALIDATION_ERROR_UNKNOWN } from '../postProcessingActions/postProcessingActions.models.esm.js';
import data from './carrier_fmr1_only_error.esm.js';
import data$1 from './cross_assay_order.esm.js';
import data$2 from './deprecated_tests.esm.js';
import data$3 from './diagnostic_rna_other_rrs_combo_error.esm.js';
import data$4 from './exome_secondary_findings_add_on_without_exome_error.esm.js';
import data$5 from './forbidden_product_types_mix.esm.js';
import data$6 from './fragile_x_only_error.esm.js';
import data$7 from './location_validation_error.esm.js';
import data$9 from './locked_gene.esm.js';
import data$a from './missing_ny_approval.esm.js';
import data$b from './patient_is_not_allowed_to_add_tests.esm.js';
import data$8 from './pcm_restricted_practice_location.esm.js';
import data$c from './preventive_combined_with_preventive_error.esm.js';
import data$d from './rna_unsupported_country_error.esm.js';

var _a;
/**
 * This is necessary because Rollup cannot analyze
 * dynamically-imported YAML files, so we must
 * "pre-import" them so they're properly bundled
 */
var modalContents = (_a = {},
    _a[ErrorType.CARRIER_FMR1_ONLY_ERROR] = data,
    _a[ErrorType.CROSS_ASSAY_ORDER] = data$1,
    _a[ErrorType.DEPRECATED_TESTS] = data$2,
    _a[ErrorType.DIAGNOSTIC_RNA_OTHER_RRS_COMBO_ERROR] = data$3,
    _a[ErrorType.EXOME_SECONDARY_FINDINGS_ADD_ON_WITHOUT_EXOME_ERROR] = data$4,
    _a[ErrorType.FORBIDDEN_PRODUCT_TYPES_MIX] = data$5,
    _a[ErrorType.FRAGILE_X_ONLY_ERROR] = data$6,
    _a[ErrorType.LOCATION_VALIDATION_ERROR] = data$7,
    _a[ErrorType.LOCATION_VALIDATION_ERROR_PCM_RESTRICTED] = data$8,
    _a[ErrorType.LOCKED_GENE] = data$9,
    _a[ErrorType.MISSING_NY_APPROVAL] = data$a,
    _a[ErrorType.PATIENT_IS_NOT_ALLOWED_TO_ADD_TESTS] = data$b,
    _a[ErrorType.PREVENTIVE_COMBINED_WITH_PREVENTIVE_ERROR] = data$c,
    _a[ErrorType.RNA_UNSUPPORTED_COUNTRY_ERROR] = data$d,
    _a);
var dynamicModalContent = function (errorType, context) {
    if (context === void 0) { context = {}; }
    var contents = modalContents[errorType];
    if (errorType === ErrorType.LOCATION_VALIDATION_ERROR &&
        isEqual(context.errorSubtypes, [LOCATION_VALIDATION_ERROR_UNKNOWN])) {
        return __assign(__assign({}, contents), { buttons: [{ isPrimary: true, text: 'OK' }] });
    }
    return contents;
};

export { modalContents as default, dynamicModalContent };
//# sourceMappingURL=index.esm.js.map
